// BOQ Hub is a set of tabs; Budget Master (project → package → revision → BOQ) lives under this address.
export const BOQ_BASE = '/boq-hub/budget-master';
